<template>
  <div>
    <table class="table table-bordered">
      <tr>
        <td>{{ $t("Order number") }}</td>
        <td>{{ orderItemOrderDescription }}</td>
      </tr>
      <tr>
        <td>{{ $t("Item") }}</td>
        <td>
          {{ orderItem.itemID }} - {{ orderItem.itemDescription }} -
          {{ orderItem.variantID }}
        </td>
      </tr>
      <tr>
        <td>{{ $t("Person") }}</td>
        <td>{{ orderItem.personDescription }}</td>
      </tr>
      <tr>
        <td>{{ $t("Options") }}</td>
        <td>
          <ul
            class="list-none ml-0 pl-0 mb-0 pt-0 pb-0 pl-0"
            style="padding-left: 0px"
          >
            <li
              v-for="option in orderItem.options"
              :key="option.optionDescription"
            >
              {{ option.optionDescription }}: {{ option.optionValue }}
            </li>
          </ul>
        </td>
      </tr>
      <tr>
        <td>{{ $t("SN") }}</td>
        <td>{{ orderItem.serialID }}</td>
      </tr>
      <tr>
        <td>{{ $t("Ref.") }}</td>
        <td>{{ orderItem.reference || "-" }}</td>
      </tr>
      <tr>
        <td>Comments</td>
        <td>{{ orderItem.comment || "-" }}</td>
      </tr>
      <!-- <tr>
        <td>{{ $t("Shipmentdate") }}</td>
        <td>{{ formatDate(orderItem.dateTimeDelivered) }}</td>
      </tr> -->
      <tr>
        <td>{{ $t("Transportmethod") }}</td>
        <td>
          {{ orderItem.transportDescription }}
          <span v-if="!orderItem.transportDescription">-</span>
        </td>
      </tr>
      <tr>
        <td>{{ $t("Track and trace") }}</td>
        <td>
          {{ orderItem.trackAndTraceDescription }}
        </td>
      </tr>
      <tr>
        <td>{{ $t("Transactiontype") }}</td>
        <td>{{ orderItem.transactionTypeID }}</td>
      </tr>
      <!-- <tr>
        FC date is not provided by API
        <td>FC Date</td>
        <td>{{orderItem.}}</td>
      </tr> -->
      <tr>
        <td>{{ $t("IC Value") }}</td>
        <td>{{ orderItem.dateTimeLastIC + " - L " + orderItem.l_IC_FDescription + " | R " + orderItem.r_IC_FDescription }}</td>
      </tr>
      <tr>
        <td>{{ $t("FC Value") }}</td>
        <td>{{ orderItem.dateTimeLastFunctionControl + " - L " + orderItem.l_FC_FDescription + " | R " + orderItem.r_FC_FDescription }}</td>
      </tr>
      <tr>
        <td>{{ $t("FC Remarks") }}</td>
        <td>{{ orderItem.remarksFunctionControl }}</td>
      </tr>
      <!-- <tr>
        LC date is not provided by API
        <td>LC Date</td>
        <td>{{orderItem.}}</td>
      </tr> -->
      <!--      <tr>-->
      <!--        <td>{{ $t("LC Value") }}</td>-->
      <!--        <td>{{ orderItem.r_IC_FDescription }}</td>-->
      <!--      </tr>-->
    </table>
  </div>
</template>
<script>
import dayjs from "dayjs";

export default {
  props: {
    selectedOrderItem: {
      type: Object,
      required: true,
    },
  },
  computed: {
    orderItem() {
      return this.selectedOrderItem ?? {};
    },
    optionsString() {
      return this.orderItem.options
        .map((option) => {
          return `${option.optionDescription}: ${option.optionValue}\n`;
        })
        .join(", ");
    },
    orderItemOrderDescription() {
      if (!this.orderItem.orderID) {
        return "-";
      }
      if (this.orderItem.orderItemID) {
        return this.orderItem.orderID + " - " + this.orderItem.orderItemID;
      }
      return this.orderItem.orderID;
    },
  },
  methods: {
    formatDate(date) {
      return dayjs(date).format("DD-MM-YYYY");
    },
  },
};
</script>
